// extracted by mini-css-extract-plugin
export default {"CheckboxList":"checkbox-list_CheckboxList__9e7nW","buttonsBlock":"checkbox-list_buttonsBlock__SbCTO","item":"checkbox-list_item__SgfYZ"};